import dynamic from "next/dynamic";
import { Component } from "react";
const RootCloseWrapper = dynamic(() => import(/* webpackChunkName: "react-overlays" */"react-overlays/lib/RootCloseWrapper"));

export default class BreadcrumbDropdownMenu extends Component {
  render() {
    const { children, onClose, open } = this.props;

    const menu = (

      <div className="dropdown-menu" onClick={this.props.onClick}>
        {children}
      </div>
    );

    if (open) {
      return (

        <RootCloseWrapper noWrap onRootClose={onClose}>
          {menu}
        </RootCloseWrapper>
      );
    }

    return menu;
  }
}
